module.exports = __webpack_public_path__ + "static/media/Smoke.7f973905.gif";